import React, { Component } from 'react';
import {  getTournamentValues,  offerPrompts, selectPrompts, stopTimer, loadRoom, AuthenticatedUser, loadPromptStatus, putToast} from "../../api"
import TournamentPageTemplate from './tournamentPageTemplate'
import CompetitorProfile from './competitorProfile'
import JudgeProfile from './judgeProfile'
import {Link} from 'react-router-dom'
import Modal from 'react-responsive-modal';
import { Redirect } from 'react-router';


class TournamentRoom extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onPromptSelected = this.onPromptSelected.bind(this);

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            roomId: params.roomId,
            tRoom: null,
            rEvent: null,
            tRound: null,
            openPrompts: false,
            promptStatus: null,
            selectedPromptKey: "0"
        }
    }

    loadTournamentPage = async (pid) => {  
        const roomId = this.state.roomId     
        if (this.state.pid) {
            loadRoom(this.state.pid).then( async d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    const {tRound, rEvent, tRoom} = getTournamentValues(d2.tournamentPage, roomId);
                    //const tEvent = await d2.tournamentPage.events.find(x=>x._id === rEvent.eventId)
                    this.setState({ pid: pid, tData: d2.tournamentPage, tUser: d2.tUser, tRoom: tRoom, rEvent: rEvent, tRound: tRound, loading: false}); 
                }
            });
        } else this.setState({ loading: false});
    };

  
    getApprovable(state) {
        if (this.state.promptStatus) {
            if (this.state.selectedPromptKey !== "0") { return true }
        }


        return false;
    }
    
    setApprovable(state) {
        const btn = document.getElementById("approveButton");

        btn.disabled = !this.getApprovable(state);
    }
    
    onOpenPrompts() {
        const {tData, tRound, rEvent, tRoom, user} = this.state        
        loadPromptStatus(tData._id, tRound._id, rEvent.eventId, tRoom._id, user._id).then(d2 => {
            if (d2 && d2.error) {
                putToast.error(d2.error)
                console.log(d2.error);
            } else {
                if (d2) { // competitor can see the prompts now so set offered date
                    offerPrompts(d2._id).then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            putToast.info(d3.message);                            
                            this.setState({ promptStatus: d3.rercPromptStatus, openPrompts: true });
                        }
                    });
                }
                else this.setState({ promptStatus: d2, openPrompts: true });
            }
        });
    }

    onPromptSelected(evt) {
        const id = evt.target.id
        //const val = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value

        let state = this.state;

        state.selectedPromptKey = id;

        this.setState(state);
    }

    onPromptsCloseModal = () => {
        if (this.state.promptStatus) {
            if (this.state.selectedPromptKey !== "0") {
                const index = this.state.selectedPromptKey.substr(9);
                selectPrompts(this.state.promptStatus._id,index).then(d3 => {
                    if (d3 && d3.error) {
                        console.log(d3.error);
                    } else {
                        putToast.info(d3.message);
                        this.setState({ promptStatus: d3.rercPromptStatus, selectedPromptKey: "0", openPrompts: false });
                    }
                });
            } else this.setState({ openPrompts: false });
        } else this.setState({ openPrompts: false });

    };
    
    onPromptsCancelModal = () => {
        if (this.state.promptStatus) {
            if (this.state.selectedPromptKey !== "0") { alert("No prompt is finalized - please use APPROVE button to finalize.") }
            else this.setState({ openPrompts: false });

        } else this.setState({ openPrompts: false });

    };
    
    componentDidMount(){
        this.loadTournamentPage();  
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params !== this.props.match.params) {
        }
    }

    render() {
        if (this.state.loading) { return null; }
        const {tData, tRound, rEvent, tRoom, user, tUser, openPrompts, promptStatus} = this.state;

        if (!tRoom) {
            return <Redirect push to={`/pages/tournament/${this.state.tData._id}`} />;
        }

        stopTimer();
        const isJudgeInRoom = tRoom.judges.find(x=>x.userId === tUser.userId);
        const isUserJudge = tUser.isJudge;
        const isUserThisRoomsJudge = isUserJudge && isJudgeInRoom;
        const isUserCompetitorInRoom = tUser.isCompetitor && tRoom.competitors.find(x=>x.userId === tUser.userId);

        const isOnlineTournament = tData.venueType === "online";
        const inactiveZoomButton = <button disabled style={{marginBottom: "8px"}} type="button" className="btn btn-warning"><i className="fa fa-film"></i>&nbsp;Video Room</button>
        const activeZoomButton = <button style={{marginBottom: "8px"}}type="button" className="btn btn-info"><i className="fa fa-film"></i>&nbsp;Video Room</button>
        const zoomLink = <a target="_blank" rel="noopener noreferrer" href={tRoom.videoLink}>{activeZoomButton}</a>        
        
        const inactiveBallotButton = <button disabled style={{marginBottom: "8px"}}type="button" className="btn btn-warning"><i className="fa fa-list"></i>&nbsp;Ballot</button>
        const activeBallotButton = <button style={{marginBottom: "8px"}}type="button" className="btn btn-info"><i className="fa fa-list"></i>&nbsp;Ballot</button>
        const ballotLink = <Link to={`/tournament/ballot/room/judge/${tData._id}/${tRoom._id}/${user._id}`}>{activeBallotButton}</Link>;

        const activePromptButton = <button style={{marginBottom: "8px"}}type="button" className="btn btn-info" onClick={() => {this.onOpenPrompts()}}><i className="fa fa-list"></i>&nbsp;Prompts</button>

        const offeredPrompts = promptStatus ? promptStatus.offeredPrompts.split("\r\n").filter(Boolean) : []
        const showButtons = (tRound.status === 'posted') || (tRound.status === 'released');

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} 
            title2={<>
                {isOnlineTournament ? showButtons ? zoomLink : inactiveZoomButton : null}&nbsp;
                {rEvent.promptListId && isUserCompetitorInRoom ? activePromptButton : null}
                {isUserThisRoomsJudge ? showButtons ? ballotLink : inactiveBallotButton : null}&nbsp;
                {(!showButtons && tRound.status !== 'closed') && '(waiting for posting ...)'}
                {tRound.status === 'closed' && '(Round Closed)'}
            </>} 
                bcTitle="Competition Room" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]}
            >
                    <div className="container-fluid"> 
                        <div className="row">
                            <div className="col-12">
                                <h3 style={{display: "inline"}}><strong>{tRoom.title} </strong> - {rEvent.title} - {tRound.title} </h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                            {tRoom.resolution && <h4 style={{paddingTop: "8px"}}><strong>Resolution:</strong> {tRoom.resolution}</h4>}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-sm-12">                            
                                <div className="row">                                
                                    <div className="col-sm-12">
                                        <h3>Competitors</h3>
                                        <br />
                                    </div>

                                </div>
                                <div className="container-fluid">
                                    <div className="row blog-media">
                                        {tRoom && tRoom.competitors && tRoom.competitors.map(competitor => 
                                            <>
                                            <CompetitorProfile mode="competitor" isUserJudge={isUserJudge} tData={tData} tRoom={tRoom} uid={competitor.userId} competitor={competitor} user={user} />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3>Judges</h3>  
                                        <br />
                                    </div>
                                </div>
                                <div className="container-fluid">
                                    {tRoom && tRoom.judges && tRoom.judges.map(judge => 
                                        <JudgeProfile mode="judge" isUserJudge={isUserJudge} uid={judge.userId} user={user}/>
                                    )}
                                </div>
                
                            </div>
                        </div>

                    </div>

                    <Modal open={openPrompts} onClose={this.onPromptsCancelModal} onCancel={this.onPromptsCancelModal}>
                        <div className="modal-header">
                            <h5 className="modal-title f-w-600" id="exampleModalLabel2">Offered Prompts</h5>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="card">
                                    <div className="card-body">
                                        {promptStatus
                                        ?
                                        <>
                                            <h4>Select your topic:</h4>
                                            <hr />
                                            <br />
                                            {offeredPrompts.map((x,index) =>{
                                                return (
                                                <div>
                                                    <input
                                                        type='checkbox'
                                                        id={`promptCB_${index}`}
                                                        checked={
                                                            this.state.selectedPromptKey === `promptCB_${index}` ||
                                                            promptStatus.finalPrompt === x
                                                        } 
                                                        onChange={this.onPromptSelected} 
                                                        disabled={promptStatus.finalPrompt}
                                                        style={{zoom: "1.2", width: "20px", height: "20px", display: "inline", marginRight: "10px"}}
                                                    /> 
                                                    <p style={{display: "inline"}}>{x}</p><hr />   
                                                </div>
                                             
                                                )
                                            })}
                                        </>
                                        : <><p>Please ask ONE of your judge(s) to reveal your prompts when you enter the Video Room.  They can do this by pressing the 'Reveal Prompts to competitor' button on your portion of their ballot. </p>
                                            <p>Once they press the button, you can leave this box and re-press the 'Prompts' button to see your prompts.</p></>
                                        }
                                    </div>
                                </div>        
                            </div>
                        </div>
                        <div className="modal-footer"> 
                            {promptStatus && 
                            <>
                                <span style={{margin: "10px 12px", padding: "3px 6px"}}>PLEASE NOTE: Pressing 'Approve' with an item selected will lock in this choice.  It cannot be changed later. Do not approve until certain.</span>
                                <button id="approveButton" type="button" className="btn btn-primary" onClick={this.onPromptsCloseModal} disabled={!this.getApprovable(this.state)} >Approve</button>
                            </>}
                            {!promptStatus && 
                            <>
                                <span style={{margin: "10px 12px", padding: "3px 6px"}}>Close and re-open once judge has pressed their button.</span>
                                <button id="approveButton" type="button" className="btn btn-primary" onClick={this.onPromptsCancelModal} >Close</button>
                            </>}
                        </div>
                    </Modal>                    
            </TournamentPageTemplate>
        )
    }
}

export default TournamentRoom



